import React, { useState, useEffect } from 'react'
import image4 from '../assets/image-carousel-4.jpg'

const PHONE_NUMBER = '+91 9789112382';
const PHONE_NUMBER_TEL = '+919789112382';

const isPhoneDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
    || (navigator.maxTouchPoints > 0 && window.innerWidth <= 768);
};

const Contact = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPhoneToast, setShowPhoneToast] = useState(false);
  const [formData, setFormData] = useState({
    inquiryType: '',
    name: '',
    email: '',
    company: '',
    crewType: '',
    requirements: '',
    qualifications: '',
    experience: '',
    positionSeeking: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    let whatsappMessage = '';
    
    if (formData.inquiryType === 'company') {
      // Section 1: For Companies/Industries seeking crew
      whatsappMessage = `Hello! I am contacting you regarding crew requirements for my company/industry.

*SECTION 1 - COMPANY/INDUSTRY SEEKING CREW*

*Contact Details:*
Name: ${formData.name}
Email: ${formData.email}
Company: ${formData.company || 'N/A'}

*Crew Requirements:*
Crew Type: ${formData.crewType || 'Ship/Offshore'}
Requirements: ${formData.requirements || 'N/A'}

*Message:*
${formData.message}

Thank you!`;
    } else {
      // Section 2: For Job Seekers
      whatsappMessage = `Hello! I am contacting you regarding job opportunities.

*SECTION 2 - JOB SEEKER*

*Contact Details:*
Name: ${formData.name}
Email: ${formData.email}

*Job Seeker Details:*
Qualifications: ${formData.qualifications || 'N/A'}
Experience: ${formData.experience || 'N/A'}
Position Seeking: ${formData.positionSeeking || 'N/A'}

*Message:*
${formData.message}

Thank you!`;
    }

    const encodedMessage = encodeURIComponent(whatsappMessage);
    const whatsappNumber = '919789112382';
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    
    window.open(whatsappUrl, '_blank');
    
    setIsModalOpen(false);
    setFormData({
      inquiryType: '',
      name: '',
      email: '',
      company: '',
      crewType: '',
      requirements: '',
      qualifications: '',
      experience: '',
      positionSeeking: '',
      message: ''
    });
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handlePhoneClick = (e) => {
    if (!isPhoneDevice()) {
      e.preventDefault();
      setShowPhoneToast(true);
    }
  };

  useEffect(() => {
    if (!showPhoneToast) return;
    const timer = setTimeout(() => setShowPhoneToast(false), 4000);
    return () => clearTimeout(timer);
  }, [showPhoneToast]);

  const contactStyles = {
    container: {
      width: '100%',
      position: 'relative',
    },
    // Hero Section
    heroSection: {
      position: 'relative',
      padding: '150px 20px 100px',
      color: '#fff',
      textAlign: 'center',
      backgroundImage: `url(${image4})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '600px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      zIndex: 1,
    },
    heroOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(6, 67, 95, 0.7)',
      zIndex: 1,
    },
    heroContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      position: 'relative',
      zIndex: 2,
    },
    heroTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      marginBottom: '20px',
      fontFamily: 'Poppins, sans-serif',
      color: '#fff',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
    },
    heroSubtitle: {
      fontSize: '1.3rem',
      lineHeight: '1.8',
      opacity: 0.95,
      maxWidth: '800px',
      margin: '0 auto',
      color: '#fff',
      textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
    },
    // Contact Section
    contactSection: {
      padding: '80px 20px',
      backgroundColor: '#fff',
    },
    contactContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    sectionTitle: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: 'var(--color-primary)',
      marginBottom: '30px',
      fontFamily: 'Poppins, sans-serif',
      textAlign: 'center',
    },
    sectionSubtitle: {
      fontSize: '1.2rem',
      color: '#666',
      lineHeight: '1.8',
      marginBottom: '50px',
      textAlign: 'center',
      maxWidth: '900px',
      margin: '0 auto 50px',
    },
    contactGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '40px',
      marginTop: '50px',
    },
    contactCard: {
      backgroundColor: '#f8f9fa',
      padding: '40px 30px',
      borderRadius: '10px',
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    },
    contactCardHover: {
      transform: 'translateY(-5px)',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
    },
    contactIcon: {
      fontSize: '3.5rem',
      marginBottom: '20px',
      color: 'var(--color-secondary)',
    },
    contactTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: 'var(--color-primary)',
      marginBottom: '15px',
      fontFamily: 'Poppins, sans-serif',
    },
    contactInfo: {
      fontSize: '1.1rem',
      color: '#666',
      lineHeight: '1.8',
      marginBottom: '20px',
    },
    contactLink: {
      display: 'inline-block',
      backgroundColor: 'var(--color-secondary)',
      color: '#fff',
      padding: '12px 30px',
      borderRadius: '5px',
      textDecoration: 'none',
      fontSize: '1rem',
      fontWeight: '600',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      marginTop: '10px',
    },
    whatsappLink: {
      display: 'inline-block',
      backgroundColor: '#25D366',
      color: '#fff',
      padding: '12px 30px',
      borderRadius: '5px',
      border: 'none',
      cursor: 'pointer',
      fontSize: '1rem',
      fontWeight: '600',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      marginTop: '10px',
      fontFamily: 'Poppins, sans-serif',
    },
    // Modal Styles
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: isModalOpen ? 'flex' : 'none',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '20px',
    },
    modalContent: {
      backgroundColor: '#fff',
      borderRadius: '10px',
      padding: '40px',
      maxWidth: '600px',
      width: '100%',
      maxHeight: '90vh',
      overflowY: 'auto',
      position: 'relative',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '30px',
    },
    modalTitle: {
      fontSize: '2rem',
      fontWeight: '700',
      color: 'var(--color-primary)',
      fontFamily: 'Poppins, sans-serif',
      margin: 0,
    },
    modalClose: {
      backgroundColor: 'transparent',
      border: 'none',
      fontSize: '2rem',
      color: '#666',
      cursor: 'pointer',
      padding: 0,
      width: '40px',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      transition: 'background-color 0.3s ease',
    },
    formGroup: {
      marginBottom: '25px',
    },
    formLabel: {
      display: 'block',
      fontSize: '1rem',
      fontWeight: '600',
      color: 'var(--color-primary)',
      marginBottom: '8px',
      fontFamily: 'Poppins, sans-serif',
    },
    formInput: {
      width: '100%',
      padding: '12px 15px',
      fontSize: '1rem',
      border: '2px solid #e0e0e0',
      borderRadius: '5px',
      fontFamily: 'Poppins, sans-serif',
      transition: 'border-color 0.3s ease',
      boxSizing: 'border-box',
    },
    formInputFocus: {
      borderColor: 'var(--color-secondary)',
      outline: 'none',
    },
    formSelect: {
      width: '100%',
      padding: '12px 15px',
      fontSize: '1rem',
      border: '2px solid #e0e0e0',
      borderRadius: '5px',
      fontFamily: 'Poppins, sans-serif',
      backgroundColor: '#fff',
      cursor: 'pointer',
      transition: 'border-color 0.3s ease',
      boxSizing: 'border-box',
    },
    formTextarea: {
      width: '100%',
      padding: '12px 15px',
      fontSize: '1rem',
      border: '2px solid #e0e0e0',
      borderRadius: '5px',
      fontFamily: 'Poppins, sans-serif',
      minHeight: '120px',
      resize: 'vertical',
      transition: 'border-color 0.3s ease',
      boxSizing: 'border-box',
    },
    formButton: {
      backgroundColor: 'var(--color-secondary)',
      color: '#fff',
      padding: '15px 40px',
      fontSize: '1.1rem',
      fontWeight: '600',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      width: '100%',
      fontFamily: 'Poppins, sans-serif',
    },
    // Info Section
    infoSection: {
      padding: '80px 20px',
      backgroundColor: '#f8f9fa',
    },
    infoContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    infoGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '40px',
    },
    infoCard: {
      backgroundColor: '#fff',
      padding: '40px 30px',
      borderRadius: '10px',
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
    },
    infoTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: 'var(--color-primary)',
      marginBottom: '20px',
      fontFamily: 'Poppins, sans-serif',
    },
    infoText: {
      fontSize: '1.05rem',
      color: '#666',
      lineHeight: '1.8',
    },
    toast: {
      position: 'fixed',
      bottom: '30px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: 'var(--color-primary)',
      color: '#fff',
      padding: '16px 24px',
      borderRadius: '8px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
      fontSize: '1rem',
      fontWeight: '500',
      zIndex: 10001,
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      animation: 'slideUp 0.3s ease',
      fontFamily: 'Poppins, sans-serif',
    },
    toastPhone: {
      fontWeight: '700',
      fontSize: '1.1rem',
    },
  };

  return (
    <div style={contactStyles.container}>
      {/* Hero Section */}
      <section style={contactStyles.heroSection} data-aos="fade-down">
        <div style={contactStyles.heroOverlay}></div>
        <div style={contactStyles.heroContainer}>
          <h1 style={contactStyles.heroTitle}>Contact Us</h1>
          <p style={contactStyles.heroSubtitle}>
            Get in touch with us to discuss your offshore crew manning needs. We're here to help 
            you find the right solutions for your maritime operations.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section style={contactStyles.contactSection} data-aos="fade-up">
        <div style={contactStyles.contactContainer}>
          <h2 style={contactStyles.sectionTitle}>Get In Touch</h2>
          <p style={contactStyles.sectionSubtitle}>
            Choose your preferred method to reach out to us. We're available to assist you with 
            all your offshore crew manning requirements.
          </p>
          <div style={contactStyles.contactGrid}>
            <div
              style={contactStyles.contactCard}
              data-aos="fade-up"
              data-aos-delay="100"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, contactStyles.contactCardHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={contactStyles.contactIcon}>
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                alt="WhatsApp"
                style={{ width: '48px', height: '48px' }}
              />
              </div>
              <h3 style={contactStyles.contactTitle}>WhatsApp</h3>
              <p style={contactStyles.contactInfo}>
                Direct contact via WhatsApp for quick responses
              </p>
              <p style={{...contactStyles.contactInfo, fontWeight: '600', color: 'var(--color-primary)'}}>
                +91 9789112382
              </p>
              <button
                onClick={openModal}
                style={contactStyles.whatsappLink}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 5px 20px rgba(37, 211, 102, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Contact via WhatsApp
              </button>
            </div>

            <div
              style={contactStyles.contactCard}
              data-aos="fade-up"
              data-aos-delay="200"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, contactStyles.contactCardHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={contactStyles.contactIcon}>📞</div>
              <h3 style={contactStyles.contactTitle}>Phone</h3>
              <p style={contactStyles.contactInfo}>
                Call us during business hours anytime for immediate assistance
              </p>
              <p style={{...contactStyles.contactInfo, fontWeight: '600', color: 'var(--color-primary)'}}>
                {PHONE_NUMBER}
              </p>
              <a
                href={`tel:${PHONE_NUMBER_TEL}`}
                onClick={handlePhoneClick}
                style={contactStyles.contactLink}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Call Now
              </a>
            </div>

            <div
              style={contactStyles.contactCard}
              data-aos="fade-up"
              data-aos-delay="300"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, contactStyles.contactCardHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={contactStyles.contactIcon}>📧</div>
              <h3 style={contactStyles.contactTitle}>Email</h3>
              <p style={contactStyles.contactInfo}>
                Send us an email and we'll respond promptly
              </p>
              <p style={{...contactStyles.contactInfo, fontWeight: '600', color: 'var(--color-primary)'}}>
                santhiyagugeorge123@gmail.com
              </p>
              <a
                href="mailto:santhiyagugeorge123@gmail.com"
                style={contactStyles.contactLink}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Send Email
              </a>
            </div>

            
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section style={contactStyles.infoSection} data-aos="fade-up">
        <div style={contactStyles.infoContainer}>
          <div style={contactStyles.infoGrid}>
            <div style={contactStyles.infoCard}>
              <h3 style={contactStyles.infoTitle}>Office Hours</h3>
              <p style={contactStyles.infoText}>
                Monday - Friday: 9:00 AM - 6:00 PM<br />
                Saturday: 9:00 AM - 1:00 PM<br />
                Sunday: Closed
              </p>
            </div>
            <div style={contactStyles.infoCard}>
              <h3 style={contactStyles.infoTitle}>Response Time</h3>
              <p style={contactStyles.infoText}>
                We aim to respond to all inquiries within 24 hours. For urgent matters, 
                please contact us via WhatsApp for immediate assistance.
              </p>
            </div>
            <div style={contactStyles.infoCard}>
              <h3 style={contactStyles.infoTitle}>Location</h3>
              <p style={contactStyles.infoText}>
                No.41/2, Middle street, Uvari.<br />
                Pin. 627651.<br />
                Tirunelveli District. Tamilnadu<br />
                South India.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      <div style={contactStyles.modalOverlay} onClick={closeModal}>
        <div style={contactStyles.modalContent} onClick={(e) => e.stopPropagation()}>
          <div style={contactStyles.modalHeader}>
            <h2 style={contactStyles.modalTitle}>Contact Us</h2>
            <button
              style={contactStyles.modalClose}
              onClick={closeModal}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              ×
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div style={contactStyles.formGroup}>
              <label style={contactStyles.formLabel} htmlFor="inquiryType">
                I am *
              </label>
              <select
                id="inquiryType"
                name="inquiryType"
                value={formData.inquiryType}
                onChange={handleInputChange}
                required
                style={contactStyles.formSelect}
                onFocus={(e) => {
                  Object.assign(e.currentTarget.style, contactStyles.formInputFocus);
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = '#e0e0e0';
                }}
              >
                <option value="">Select inquiry type</option>
                <option value="company">Company/Industry - Seeking crew for ship or offshore</option>
                <option value="job_seeker">Job Seeker - Looking for employment</option>
              </select>
            </div>
            <div style={contactStyles.formGroup}>
              <label style={contactStyles.formLabel} htmlFor="name">
                Name *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                style={contactStyles.formInput}
                onFocus={(e) => {
                  Object.assign(e.currentTarget.style, contactStyles.formInputFocus);
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = '#e0e0e0';
                }}
                placeholder="Enter your full name"
              />
            </div>
            <div style={contactStyles.formGroup}>
              <label style={contactStyles.formLabel} htmlFor="email">
                Email *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                style={contactStyles.formInput}
                onFocus={(e) => {
                  Object.assign(e.currentTarget.style, contactStyles.formInputFocus);
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = '#e0e0e0';
                }}
                placeholder="Enter your email address"
              />
            </div>

            {formData.inquiryType === 'company' && (
              <>
                <div style={contactStyles.formGroup}>
                  <label style={contactStyles.formLabel} htmlFor="company">
                    Company Name
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    style={contactStyles.formInput}
                    onFocus={(e) => {
                      Object.assign(e.currentTarget.style, contactStyles.formInputFocus);
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = '#e0e0e0';
                    }}
                    placeholder="Your company or industry name"
                  />
                </div>
                <div style={contactStyles.formGroup}>
                  <label style={contactStyles.formLabel} htmlFor="crewType">
                    Crew Type Needed
                  </label>
                  <select
                    id="crewType"
                    name="crewType"
                    value={formData.crewType}
                    onChange={handleInputChange}
                    style={contactStyles.formSelect}
                    onFocus={(e) => {
                      Object.assign(e.currentTarget.style, contactStyles.formInputFocus);
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = '#e0e0e0';
                    }}
                  >
                    <option value="">Select crew type</option>
                    <option value="Ship">Ship Crew</option>
                    <option value="Offshore">Offshore Crew</option>
                    <option value="Both">Both Ship & Offshore</option>
                  </select>
                </div>
                <div style={contactStyles.formGroup}>
                  <label style={contactStyles.formLabel} htmlFor="requirements">
                    Crew Requirements
                  </label>
                  <textarea
                    id="requirements"
                    name="requirements"
                    value={formData.requirements}
                    onChange={handleInputChange}
                    style={contactStyles.formTextarea}
                    onFocus={(e) => {
                      Object.assign(e.currentTarget.style, contactStyles.formInputFocus);
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = '#e0e0e0';
                    }}
                    placeholder="Describe your crew requirements (positions, certifications, etc.)"
                  />
                </div>
              </>
            )}

            {formData.inquiryType === 'job_seeker' && (
              <>
                <div style={contactStyles.formGroup}>
                  <label style={contactStyles.formLabel} htmlFor="qualifications">
                    Qualifications
                  </label>
                  <input
                    type="text"
                    id="qualifications"
                    name="qualifications"
                    value={formData.qualifications}
                    onChange={handleInputChange}
                    style={contactStyles.formInput}
                    onFocus={(e) => {
                      Object.assign(e.currentTarget.style, contactStyles.formInputFocus);
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = '#e0e0e0';
                    }}
                    placeholder="Your certifications and qualifications"
                  />
                </div>
                <div style={contactStyles.formGroup}>
                  <label style={contactStyles.formLabel} htmlFor="experience">
                    Experience
                  </label>
                  <input
                    type="text"
                    id="experience"
                    name="experience"
                    value={formData.experience}
                    onChange={handleInputChange}
                    style={contactStyles.formInput}
                    onFocus={(e) => {
                      Object.assign(e.currentTarget.style, contactStyles.formInputFocus);
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = '#e0e0e0';
                    }}
                    placeholder="Years of experience and previous roles"
                  />
                </div>
                <div style={contactStyles.formGroup}>
                  <label style={contactStyles.formLabel} htmlFor="positionSeeking">
                    Position Seeking
                  </label>
                  <input
                    type="text"
                    id="positionSeeking"
                    name="positionSeeking"
                    value={formData.positionSeeking}
                    onChange={handleInputChange}
                    style={contactStyles.formInput}
                    onFocus={(e) => {
                      Object.assign(e.currentTarget.style, contactStyles.formInputFocus);
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = '#e0e0e0';
                    }}
                    placeholder="e.g. Deck Officer, Engineer, Offshore"
                  />
                </div>
              </>
            )}

            <div style={contactStyles.formGroup}>
              <label style={contactStyles.formLabel} htmlFor="message">
                Message *
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                required
                style={contactStyles.formTextarea}
                onFocus={(e) => {
                  Object.assign(e.currentTarget.style, contactStyles.formInputFocus);
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = '#e0e0e0';
                }}
                placeholder="Tell us more about your inquiry"
              />
            </div>
            <button
              type="submit"
              style={contactStyles.formButton}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.02)';
                e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Submit
            </button>
          </form>
        </div>
      </div>

      {/* Phone Toast - shown when clicking Call on non-phone devices */}
      {showPhoneToast && (
        <div style={contactStyles.toast}>
          <span>📞</span>
          <span>
            Call us at <span style={contactStyles.toastPhone}>{PHONE_NUMBER}</span>
          </span>
        </div>
      )}
    </div>
  )
}

export default Contact